import { commonFunctions } from './common-functions';
var BssListenersHandler = /** @class */ (function () {
    function BssListenersHandler(elementRenderer, options, onUpdateFinance) {
        this._elementRenderer = null;
        this._options = null;
        this._productType = null;
        this._bindListeners = {
            onCreateFlow: null,
            onUpdateFinance: null,
            onEntityCreated: null,
            onDestroyFlow: null,
        };
        this._validateRenderer(elementRenderer, options);
        this._options = options;
        this._elementRenderer = elementRenderer;
        this._productType = this._elementRenderer.initFunctionType;
        this._setContainerSelector();
        this._setIntegrationMode();
        commonFunctions.initLoader(this._elementRenderer.containerSelector);
        this._initBindFunctions(onUpdateFinance);
    }
    BssListenersHandler.prototype._validateRenderer = function (elementRenderer, options) {
        if (this._options) {
            console.warn('[BSS] Internal variable _options not destroyed properly');
        }
        if (this._elementRenderer) {
            console.warn('[BSS] Internal variable _elementRenderer not destroyed properly');
        }
        if (!options.configuration) {
            console.warn('[BSS] Simulator configuration are not defined!');
        }
        if (elementRenderer.isInited) {
            console.warn('[BSS]  Doubleclick - simulator has been already inited');
        }
    };
    BssListenersHandler.prototype._setContainerSelector = function () {
        var _a;
        var targetElement = this._options.target;
        if (((_a = this._options.target) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            targetElement = this._options.target[0];
        }
        if (!targetElement.id) {
            targetElement.id = this._generateEntitySelector();
        }
        this._elementRenderer.containerSelector = "#".concat(targetElement.id);
    };
    BssListenersHandler.prototype._generateEntitySelector = function () {
        return "bss-entity-id-".concat(Math.random().toString(32).substring(2));
    };
    BssListenersHandler.prototype._setIntegrationMode = function () {
        this.bodyInjection =
            this._options.isAppendedToBody === true ||
                this._options.isAppendedToBody === 'true';
        if (this.bodyInjection) {
            this._options.integrationMode = 'inpage';
        }
        else {
            this._options.integrationMode = 'overlayer';
        }
    };
    BssListenersHandler.prototype.getInitBssListenersFunction = function () {
        if (!this._elementRenderer) {
            throw Error('Element renderer not set!');
        }
        return this._initBSSListeners.bind(this);
    };
    BssListenersHandler.prototype._initBSSListeners = function () {
        document.addEventListener('bss-entity-created-' + this._elementRenderer.BSSController.flowId, this._bindListeners.onEntityCreated);
        document.addEventListener('bss-flow-config-ready', this._bindListeners.onCreateFlow);
        document.addEventListener('bss-close-entity-' + this._elementRenderer.BSSController.flowId, this._bindListeners.onUpdateFinance);
        document.addEventListener('bss-destroy-connector-event', this._bindListeners.onDestroy);
        if (this._elementRenderer.onAdditionalConfigApply) {
            document.addEventListener('bss-additional-config-apply', this._elementRenderer.onAdditionalConfigApply);
        }
        document.addEventListener('bss-run-simulator-in-widget', this._elementRenderer.BSSController.onOpenSimulatorInWidget);
        document.addEventListener('bss-run-simulator-in-widget-aph', this._elementRenderer.BSSController.onOpenSimulatorInWidgetAph);
        document.addEventListener('bss-run-standalone-simulator', this._elementRenderer.BSSController.onStandaloneClick);
        document.addEventListener('bss-remove-simulator-in-widget-aph', this._elementRenderer.BSSController.onRemoveSimulatorInWidgetAph);
        document.addEventListener('bss_cf_step_changed', this._elementRenderer.BSSController.onCompareFinanceInWidgetAph);
        this._destroyFlowOnCloseMaterialBox();
    };
    BssListenersHandler.prototype._initBindFunctions = function (onUpdateFinance) {
        this._bindListeners.onUpdateFinance = onUpdateFinance;
        this._bindListeners.onCreateFlow = this._createFlow.bind(this);
        this._bindListeners.onEntityCreated = this._onEntityCreated.bind(this);
        this._bindListeners.onDestroy = this._onDestroyFlow.bind(this);
    };
    BssListenersHandler.prototype._destroyFlowOnCloseMaterialBox = function () {
        var _a;
        var self = this;
        // eslint-disable-next-line no-undef
        if ((_a = T1 === null || T1 === void 0 ? void 0 : T1.channels) === null || _a === void 0 ? void 0 : _a.dialog) {
            // eslint-disable-next-line no-undef
            T1.channels.dialog.subscribe(
            // eslint-disable-next-line no-undef
            T1.constants.MATERIALBOX_CLOSED, function () {
                /* code to execute whenever a material box has been closed */
                self._onDestroyFlow();
            });
        }
    };
    BssListenersHandler.prototype._onEntityCreated = function () {
        if (window.PreLoader) {
            window.PreLoader.stop();
            if (typeof postal !== 'undefined') {
                postal.publish({
                    channel: 'com.toyota.tme.t1.finance',
                    topic: 'component.rendered',
                    data: {},
                });
            }
        }
        if (this._productType === 'INIT_SC' && !self.taggingScripts) {
            //Tagging script
            (function () {
                var tagjs = document.createElement('script');
                var s = document.getElementsByTagName('script')[0];
                tagjs.async = true;
                tagjs.src = 'https://s.btstatic.com/tag.js#site=H8SYQMW';
                s.parentNode.insertBefore(tagjs, s);
            })();
            self.taggingScripts = true;
        }
        if (this._elementRenderer.onEntityCreated) {
            this._elementRenderer.onEntityCreated();
        }
    };
    BssListenersHandler.prototype._createFlow = function () {
        if (!this._elementRenderer.configData) {
            return;
        }
        if (this._elementRenderer.withPopupContainer &&
            !this._elementRenderer.isPopupActive) {
            return;
        }
        if (this._productType === 'INIT_NC' || this._productType === 'INIT_SC') {
            this._setFinanceQuoteId(this._elementRenderer);
        }
        if (this._elementRenderer.containerSelector) {
            this._elementRenderer.BSSController.setContainer(this._elementRenderer.containerSelector);
            document
                .querySelector(this._elementRenderer.containerSelector)
                .classList.add('bss-amd', "bss-appended-to-".concat(this.bodyInjection ? 'body' : 'popup'));
        }
        else {
            console.error(new Error('"options.target" element is not defined!'));
        }
        var initialData = commonFunctions.prepareData(this._elementRenderer, this._elementRenderer.initOptions);
        this._elementRenderer.BSSController.setParams(initialData);
        this._elementRenderer.BSSController.createFlow();
    };
    BssListenersHandler.prototype._onDestroyFlow = function () {
        var _this = this;
        setTimeout(function () {
            var _a;
            if (!((_a = _this._elementRenderer) === null || _a === void 0 ? void 0 : _a.BSSController)) {
                return;
            }
            document.removeEventListener('bss-entity-created-' + _this._elementRenderer.BSSController.flowId, _this._bindListeners.onEntityCreated);
            document.removeEventListener('bss-flow-config-ready', _this._bindListeners.onCreateFlow);
            document.removeEventListener('bss-destroy-connector-event', _this._bindListeners.onDestroyFlow);
            document.removeEventListener('bss-close-entity-' + _this._elementRenderer.BSSController.flowId, _this._bindListeners.onUpdateFinance);
            document.removeEventListener('bss-run-simulator-in-widget', _this._elementRenderer.BSSController.onOpenSimulatorInWidget);
            document.removeEventListener('bss-run-simulator-in-widget-aph', _this._elementRenderer.BSSController.onOpenSimulatorInWidgetAph);
            document.removeEventListener('bss-run-standalone-simulator', _this._elementRenderer.BSSController.onStandaloneClick);
            document.removeEventListener('bss-remove-simulator-in-widget-aph', _this._elementRenderer.BSSController.onRemoveSimulatorInWidgetAph);
            document.removeEventListener('bss_cf_step_changed', _this._elementRenderer.BSSController.onCompareFinanceInWidgetAph);
            _this._elementRenderer.BSSController.destroyFlow();
            _this._elementRenderer.BSSController = null;
            _this._elementRenderer.isInited = false;
            _this._destroyBindFunctions();
        });
    };
    BssListenersHandler.prototype._destroyBindFunctions = function () {
        this._bindListeners.onCreateFlow = null;
        this._bindListeners.onDestroyFlow = null;
        this._bindListeners.onEntityCreated = null;
        this._bindListeners.onUpdateFinance = null;
        this._options = null;
        this._productType = null;
        this._elementRenderer = null;
    };
    BssListenersHandler.prototype._setFinanceQuoteId = function () {
        var FinanceQuoteId;
        var self = this;
        window.fqs.get().done(function (data) {
            FinanceQuoteId = data.finance;
            if (FinanceQuoteId) {
                self._elementRenderer.configData.quoteId = FinanceQuoteId;
            }
        });
    };
    return BssListenersHandler;
}());
export { BssListenersHandler };
